const Loader = ({ title = '' }) => {
  return (
    <div className="spinner-border" role="status">
      <span className="sr-only">{title}</span>
    </div>
  )
}

export default Loader
